import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import "./DropDownButtons.scss"; // Import the styles

const DropDownButtons = ({
  showCount,
  setCreatePresentationFields,
  createPresentationFields,
  refreshComp,
  switchToCreatedBy,
  searchClickEdetail,
  sendSearchDataToEdetails
 
}) => {
  const [activeButton, setActiveButton] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [items, setItems] = useState(['Created By Me', 'Created By Others', 'All'])
  const [activeCount, setActiveCount] = useState("");

  const handleButtonClick = (buttonIndex) => {
    if (items[buttonIndex].includes('Me')) {
      if (searchClickEdetail) {
        sendSearchDataToEdetails({...createPresentationFields, created:"me"}, 'search')
      }else{switchToCreatedBy("me")}
      
    } else if (items[buttonIndex].includes('Others')) {
      if (searchClickEdetail) {
        sendSearchDataToEdetails({...createPresentationFields, created:"others"}, 'search')
      }else{switchToCreatedBy("others")}
      
    } else {
      if (searchClickEdetail) {
        sendSearchDataToEdetails({...createPresentationFields, created:"all"}, 'search')
      }else{switchToCreatedBy("all")}
    }
    setActiveButton(buttonIndex);
    setDropdownOpen(false); // Close the dropdown
  };

  const toggleDropdown = (isOpen) => {
    setDropdownOpen(isOpen);
  };

  useEffect(() => {
    setActiveButton(0)
    setActiveCount(showCount[items[activeButton].trim().charAt(0).toLowerCase() + items[activeButton].replace(/\s/g, "").slice(1)] || 0)
  },[])

  
  return (
    <Dropdown
      show={dropdownOpen}
      onToggle={toggleDropdown}
      className="dropdown-button"
    >
      <Dropdown.Toggle onClick={() => setDropdownOpen(!dropdownOpen)}>
       {items[activeButton]} {`(${showCount[items[activeButton].trim().charAt(0).toLowerCase() + items[activeButton].replace(/\s/g, "").slice(1)] || 0})`}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {items.map((item, index)=> <Dropdown.Item
           onClick={() => {//showSelected("me");
            handleButtonClick(index)}
           }
          as="button"
          className={`btnLink ${activeButton === index ? "activeButton" : ""}`}
          style={{
           
          }}
          key={index + item}
        >
          <span>
            {item} {searchClickEdetail && item === items[activeButton]?`(${showCount[items[activeButton].trim().charAt(0).toLowerCase() + items[activeButton].replace(/\s/g, "").slice(1)] || 0})`: searchClickEdetail?'':`(${showCount[item.trim().charAt(0).toLowerCase() + item.replace(/\s/g, "").slice(1)] || 0})`}              
          </span>
        </Dropdown.Item>)}
       
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownButtons;
